import merchantGatewayApi from 'apis/merchant-gateway/api';
import { OfferingPlatformScope } from 'modules/shared-menu/types';

import { ProductSearchResponse, Product, GenerateAiDescriptionResponse } from './types';

export const OFFER_LISTING_SERVICE = '/offer-listing-service';

export const searchCatalogProductsByGtins = async (gtins: string[], scope: OfferingPlatformScope): Promise<Product[]> =>
  merchantGatewayApi
    .post<ProductSearchResponse>(`${OFFER_LISTING_SERVICE}/search-product/by-gtins`, {
      gtins,
      scope,
    })
    .then(response => response.data);

export const searchCatalogProducts = async (query: string, scope: OfferingPlatformScope): Promise<Product[]> =>
  merchantGatewayApi
    .post<ProductSearchResponse>(`${OFFER_LISTING_SERVICE}/search-product/query`, {
      query,
      scope,
    })
    .then(response => response.data);

export const getProductById = async (productId: string): Promise<Product> =>
  merchantGatewayApi.get<Product>(`${OFFER_LISTING_SERVICE}/product/${productId}`).then(response => response.data);

export const importXmenuJson = (venueId: string, jsonFile: any) =>
  merchantGatewayApi.post(`${OFFER_LISTING_SERVICE}/xmenu/${venueId}`, { ...jsonFile }).then(response => response.data);

export const generateAiDescription = async (prompt: string, language: Language) =>
  merchantGatewayApi
    .post<GenerateAiDescriptionResponse>(`${OFFER_LISTING_SERVICE}/ai/offer/descriptions`, { prompt, language })
    .then(response => response.data);
